module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 7-e79f42d234568dffc290690caba07ed2.png";